import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { ProjectPage } from './pages/ProjectPage';
import { ProjectsPage } from './pages/ProjectsPage';
import { PlaygroundPage } from './pages/PlaygroundPage';
import { ScrollToHash, SEOJsonLd } from './components/common';
import { LanguageProvider } from './i18n';
import './styles/global.css';

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <SEOJsonLd />
        <ScrollToHash />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/proyecto/:projectId" element={<ProjectPage />} />
          <Route path="/proyectos" element={<ProjectsPage />} />
          <Route path="/playground" element={<PlaygroundPage />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
